import axiosClient from "../../../../axiosClient"

export default async (caseId) => {
    const result = await axiosClient.get(`/background-verification-result/${caseId}`)

    return result.data
}
